import { useQuery } from "./urqlHooks";

const DASHBOARD = `
query landing_data($companyId:String!){
    Landing(companyId:$companyId){
    id,
    receivable,
    toPay,
    bankAcountAmount,
    bankCreditAmount,
    last12MonthSales{
      month,
      sales,
      label
    },
    expiredVsValidSales{
      expired,
      valid
    },
    paimentColectionTable{
    rut,
    name,
    valid,
    expired30,
    expired60,
    expired90,
    expiredOlder,
    },
    lastBankUpdate
  }
}
`;

export const GetDashboarData = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: DASHBOARD,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_SII_SALES = `
  query GET_SII_SALES_12_MONTHS($companyId: String!) {
    get12MonthsNetSales(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSII12MonthsSales = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_SII_SALES,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_LAST_SII_SALES = `
  query GET_SII_SALES_LAST_12_MONTHS($companyId: String!) {
    getLast12MonthsNetSales(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSIILast12MonthsSales = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_LAST_SII_SALES,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}




const GET_SII_PURCHASES = `
  query GET_SII_PURCHASES_12_MONTHS($companyId: String!) {
    get12MonthsNetPurchases(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSII12MonthsPurchases = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_SII_PURCHASES,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_LAST_SII_PURCHASES = `
  query GET_SII_PURCHASES_LAST_12_MONTHS($companyId: String!) {
    getLast12MonthsNetPurchases(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSIILast12MonthsPurchases = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_LAST_SII_PURCHASES,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}










const GET_DASHBOARD_CARDS = `
  query GET_DASHBOARD_CARDS($companyId: String!) {
    dashboardCards(companyId: $companyId){
      bankAcountAmount
      bankCreditAmount
      toPay
      toReceive
    }
  }
`;

export const GetDashboardCards = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_DASHBOARD_CARDS,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_PENDING_PAYMENTS = `
  query GET_PENDING_PAYMENTS($companyId: String!) {
    findPaymentCollection(companyId: $companyId){
      rut
      name
      outsideProviderId
      valid
      expired30
      expired60
      expired90
      expiredOlder
      documents
    }
  }
`;

export const GetPendingPaymentDashboard = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_PENDING_PAYMENTS,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const PAYABLERECEIVABLESUMMARY = `
query payable_summary($companyId:String!, $isPayable:Boolean!){
  getPayableReceivableSummary(companyId:$companyId, isPayable:$isPayable){
    valid{
      documentType,
      amount,
      summary
    },
    expired30{
      documentType,
      amount,
      summary
    },
    expired60{
      documentType,
      amount,
      summary
    },
    expired90{
      documentType,
      amount,
      summary
    },
    expiredOlder{
      documentType,
      amount,
      summary
    }
  }
}
`;

export const GetPayableReceivableSummary = (companyId, isPayable) => {
  const [result, reexecuteQuery] = useQuery({
    query: PAYABLERECEIVABLESUMMARY,
    variables: { companyId, isPayable },
    pause: !companyId, // Don't execute if companyId is missing
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const TOTALINVOICES = `
query INVOICES_TOTAL($companyId: String!){
  getTotalInvoice(companyId: $companyId){
    amount
  }
}`;

export const GetTotalInvoices = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: TOTALINVOICES,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const TOTAL_CHECKS = `
query TOTAL_CHECKS($companyId: String!, $isReceived: Boolean!){
  getTotalChecks(companyId: $companyId, isReceived: $isReceived){
    amount
  }
}`;

export const GetChecks = (companyId, isReceived) => {
  const [result, reexecuteQuery] = useQuery({
    query: TOTAL_CHECKS,
    variables: { companyId, isReceived },
    pause: !companyId, // Don't execute if companyId is missing
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_OTHER_INCOME = `
query GET_OTHER_INCOME($companyId: String!){
  getOtherIncome(companyId: $companyId){
    amount
  }
}`;

export const GetTotalOtherIncome = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_OTHER_INCOME,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

/** Listado de empresas para Layout: igual que antes en campos; ganancia principal = cache-and-network + menos refetch en Layout. */
const COMPANYLIST_LIGHT = `
query COMPANIES_BY_USER {
  companiesByUser {
    id
    group {
      groupId
      groupName
    }
    users {
      userId
      role
      modulePermissions {
        moduleId
        hasAccess
        excludedFeatures
      }
    }
    name
    rut
    plan
    adminStatus
    blockedFeatures
    modulePermissions {
      moduleId
      hasAccess
      excludedFeatures
    }
    providerPaymentDays
    clientPaymentDays
    trialExpirationDate
    suscriptionId
    alias
    correlative
    taxRecoverable
    taxAdditional
    autoPostponeF29
    taxAdditionalAccount {
      accountKey
      accountName
    }
    payDebitNotes
    paySalaries
    ppmRate
    siiBienesRaices {
      totalAvaluoFiscal
      properties
      fetchedAt
    }
    reconstructionReport {
      generatedAt
      totalAvaluoFiscal
      properties
      hasPdf
    }
    requiresAccountingReconstruction
    accountingReconstructionStatus
    splitCreditCardRenditions
    isPascaleActive {
      active
      mode
      reportsFrom
    }
    softlanding {
      isCompleted
      contactStepSet
    }
  }
}
`;

export const GetCompanyList = () => {
  const [result, reexecuteQuery] = useQuery({
    query: COMPANYLIST_LIGHT,
    variables: {},
    requestPolicy: 'cache-and-network',
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const CONCILIATION_RATIO = `
query ratio ($companyId:String!,$month: DateTime!){
  getMonthlyMatchsRatio(companyId:$companyId,month:$month)
}`;

export const GetConciliationRatio = (companyId, month) => {
  const [result, reExecuteQuery] = useQuery({
    query: CONCILIATION_RATIO,
    variables: { companyId, month },
    pause: !companyId || !month, // Don't execute if companyId or month is missing
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reExecuteQuery };
};

const GET_FLOW_STRUCTURE = `query GetFlowStructure($companyId: String!) {
  getFlowStructure(companyId: $companyId){
    report {
      INCOME {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isTotal
        isDefault
        isVisible
        fields {
          label
          cashflowAreaId
          isIncome
          isVisible
          isDefault
          isHidden
        }
        values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          isClickable
          documents
        }
      }
      
      EXPENSE {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isTotal
        isDefault
        isVisible
        fields {
          label
          cashflowAreaId
          isIncome
          isVisible
          isDefault
          isHidden
        }
        values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          isClickable
          documents
        }
      }
    }
    weekValues {
      start
      end
      startAmount
      endAmount
      variationAmount
      primaryView
    }
    monthValues {
      start
      end
      startAmount
      endAmount
      variationAmount
      primaryView
    }
    dayValues {
      start
      end
      startAmount
      endAmount
      variationAmount
      primaryView
    }
    updatedAt
  }
}`

export const GetFlowStructure = (companyId) => {
  const [flowResult, reExecuteQuery] = useQuery({
    query: GET_FLOW_STRUCTURE,
    variables: { companyId },
    pause: !companyId, // Don't execute if companyId is missing
  });
  const { data, fetching, error } = flowResult;
  return { data, fetching, error, reExecuteQuery };
};

const GET_HISTORICAL_MONTHLY_RECONCILIATIONS = `
  query getHistoricalMonthlyReconciliations($companyId: String!) {
      getHistoricalMonthlyReconciliations(companyId: $companyId){
          banks{
              accountNumber
              bankId
              currency
              receivedTransactionsCount
              receivedTransactionsTotal
              reconciledTransactionsCount
              spendTransactionsCount
              spendTransactionsTotal
              transactionsCount
              transactionsTotalAmount
          }
          currenciesSummary{
              currency
              receivedTransactionsTotal
              reconciledTransactionsCount
              spendTransactionsTotal
              transactionsCount
          }
          period
          reconciledTransactionsCount
          transactionsCount
      }
  }
`;

export const GetHistoricalMonthlyReconciliations = (variables, { pause } = {}) => {
  const [result, reExecuteQuery] = useQuery({
    query: GET_HISTORICAL_MONTHLY_RECONCILIATIONS,
    variables,
    pause: pause ?? false,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reExecuteQuery };
};

const GET_HISTORICAL_MONTHLY_RECONCILIATIONS_BY_MATCH_SOURCE = `
  query getHistoricalMonthlyReconciliationsByMatchSource($companyId: String!) {
    getHistoricalMonthlyReconciliationsByMatchSource(companyId: $companyId) {
      period
      totalReconciledAmount
      totalMatchesCount
      matchSources {
        matchSource
        reconciledAmount
        matchesCount
        percentage
        userEmails {
          email
          matchesCount
        }
      }
    }
  }
`;

export const GetHistoricalMonthlyReconciliationsByMatchSource = (variables) => {
  const [result, reExecuteQuery] = useQuery({
    query: GET_HISTORICAL_MONTHLY_RECONCILIATIONS_BY_MATCH_SOURCE,
    variables,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reExecuteQuery };
};